<ion-content>
  <ion-datetime
      #date
      [presentation]="tipo"
      first-day-of-week="1"
      [value]="fecha"
      size="cover"
      [min]="min"
      [max]="max"
      [preferWheel]="rueda"
      [showAdjacentDays]="true"
      minuteValues="0,5,10,15,20,25,30,35,40,45,50,55"
  >
    <div slot="title">{{titulo}}</div>
    <ion-buttons slot="buttons">
      @if (now) {
        <ion-button color="secondary" (click)="nowfn()">AHORA</ion-button>
      }
      @if (borrar) {
        <ion-button color="dark" (click)="reset()">BORRAR</ion-button>
      }
      <ion-button color="danger" (click)="cancel()">CANCELAR</ion-button>
      <ion-button color="primary" (click)="go()">ELEGIR</ion-button>
    </ion-buttons>
  </ion-datetime>
</ion-content>